<template>
  <div class="wr">
    <div class="wr-card">
      <div class="wr-icon">
        <svg viewBox="0 0 24 24">
          <rect x="3" y="6" width="18" height="13" rx="3" />
          <path d="M3 10h18" />
          <circle cx="17" cy="14" r="1.4" fill="currentColor" stroke="none" />
        </svg>
      </div>

      <h1 class="wr-title">{{ $t("title") }}</h1>
      <p class="wr-desc">{{ $t("desc") }}</p>

      <div v-if="wallets.length" class="wr-list">
        <a
          v-for="w in wallets"
          :key="w.name"
          class="wr-item"
          :href="w.href"
          rel="noopener"
        >
          <span class="wr-name">{{ w.name }}</span>
          <svg class="wr-arrow" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" /></svg>
        </a>
      </div>

      <p class="wr-tip">{{ $t("tip") }}</p>
    </div>
  </div>
</template>

<script>
import { buildWalletOpenLinks } from "../recovered/wallet-session";

export default {
  name: "WalletRequired",
  i18n: {
    zh: {
      title: "请在钱包 App 内打开",
      desc: "本页面需要在钱包环境中使用，请用下列任一钱包 App 打开本链接。",
      tip: "已在钱包内打开却仍看到此页？请刷新页面，或确认钱包已解锁。",
    },
    en: {
      title: "Please open in a wallet app",
      desc: "This page requires a wallet environment. Open this link in one of the wallet apps below.",
      tip: "Already inside a wallet but still seeing this? Refresh, or make sure your wallet is unlocked.",
    },
  },
  computed: {
    wallets() {
      try {
        return buildWalletOpenLinks(window.location.href) || [];
      } catch (e) {
        return [];
      }
    },
  },
};
</script>

<style scoped>
.wr {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: var(--pool-ink, #080b16);
}

.wr-card {
  width: 100%;
  max-width: 360px;
  padding: 32px 22px 26px;
  border-radius: var(--pool-r, 18px);
  border: 1px solid var(--pool-line, rgba(150, 167, 214, 0.14));
  background: linear-gradient(160deg, #10162c, var(--pool-ink-2, #0b1022));
  text-align: center;
}

.wr-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 18px;
  border-radius: 16px;
  display: grid;
  place-items: center;
  background: var(--pool-grad, linear-gradient(120deg, #33e2c7, #4b86ff));
}
.wr-icon svg {
  width: 30px;
  height: 30px;
  stroke: #04211c;
  fill: none;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.wr-title {
  margin: 0 0 10px;
  font-size: 19px;
  font-weight: 700;
  color: var(--pool-text, #eaf0ff);
}

.wr-desc {
  margin: 0 0 20px;
  font-size: 13px;
  line-height: 1.7;
  color: var(--pool-muted, #828daa);
}

.wr-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 18px;
}

.wr-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 0 16px;
  border-radius: 12px;
  border: 1px solid var(--pool-line, rgba(150, 167, 214, 0.14));
  background: var(--pool-glass, rgba(150, 170, 225, 0.055));
  color: var(--pool-text, #eaf0ff);
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
}
.wr-item:active {
  background: var(--pool-glass-2, rgba(150, 170, 225, 0.09));
}

.wr-arrow {
  width: 16px;
  height: 16px;
  stroke: var(--pool-faint, #5a637f);
  fill: none;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.wr-tip {
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
  color: var(--pool-faint, #5a637f);
}
</style>
